module.exports = __webpack_public_path__ + "img/0.6749fcb7.png";